import { useEffect, useState } from 'react';
import './App.css';
import LoginPage from './components/loginPage/loginPage';
import MainPage from './components/mainPage/mainPage';

export default function App() {
  const [user, setUser] = useState(null);
  const [url, setUrl] = useState('http://localhost:3009');

  useEffect(() => {
    // if(process.env.REACT_APP_API_PROTO) {
    //   setUrl(`${process.env.REACT_APP_API_PROTO}://${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}`)
    // }
    setUrl('https://server.lifemngr.com:443');
  }, [url])
  

  useEffect(() => {
    if(localStorage.getItem("adminC_userdata") != null) {
      fetch(`${url}/lm_api/adminC/login`, {
        headers: { 'Content-Type': 'application/json' },
        method: 'post',
        body: JSON.stringify({ 
          username: localStorage.getItem("adminC_userdata").split("-,-")[0], 
          UPassword: localStorage.getItem("adminC_userdata").split("-,-")[1], 
          password: process.env.REACT_APP_API_PASSWORD 
        }),
      }).then(res=>res.json()).then((res) => {
        setUser(res);
      }).catch(err=>console.error(err));
    }
  }, [url])

  return <div className="App">
    {user
      ? <MainPage url={url} user={user}/>
      : <LoginPage setUser={setUser} url={url}/>
    }
  </div>
}